export async function estimateTotalWithLookAhead (getPage, baseParams, {
  batchSize,
  firstPageItems,
  currentOffset,
  maxPrefetchItems = 200,
  maxPagesAhead = 3
}) {
  const size = Math.max(1, Number(batchSize) || 1)
  const firstCount = Array.isArray(firstPageItems) ? firstPageItems.length : 0
  const offsetStart = Math.max(0, Number(currentOffset) || 0)

  if (firstCount < size) {
    return offsetStart + firstCount
  }

  const maxPagesByBudget = Math.max(1, Math.floor(maxPrefetchItems / size))
  const pagesAhead = Math.max(1, Math.min(maxPagesAhead, maxPagesByBudget - 1))
  let remainingBudget = Math.max(0, maxPrefetchItems - firstCount)
  let offset = offsetStart + firstCount

  for (let i = 0; i < pagesAhead && remainingBudget > 0; i++) {
    const nextLimit = Math.min(size, remainingBudget)
    const result = await getPage({ ...baseParams, limit: nextLimit, offset })
    const items = Array.isArray(result?.pageItems)
      ? result.pageItems
      : (Array.isArray(result?.data?.value) ? result.data.value : [])
    const loaded = items.length

    if (loaded < nextLimit) {
      return offset + loaded
    }

    offset += nextLimit
    remainingBudget -= nextLimit
  }

  // Unknown exact end: keep one extra item so user can navigate forward and trigger next-page fetch.
  return offset + 1
}

export function getPrefetchPagesAhead (limit, maxPrefetchItems = 200, maxPagesAhead = 2) {
  const safeLimit = Math.max(1, Number(limit) || 1)
  const remainingBudget = Math.max(0, Number(maxPrefetchItems) - safeLimit)
  return Math.max(0, Math.min(maxPagesAhead, Math.floor(remainingBudget / safeLimit)))
}
